import { Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { HROUTES } from './navigation-routes.config';
import { LayoutService } from '../services/layout.service';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { decryptValue } from '../data/encryption';


@Component({
  selector: 'app-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss']
})
export class HorizontalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  public menuItems: any[];
  public config: any = {};
  level: number = 0;
  transparentBGClass = "";
  menuPosition = 'Side';
  isAdmin = false;
  isCustomer = false;
  isCustomerAdmin = false;

  layoutSub: Subscription;

  constructor(private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private router: Router) {
    this.config = this.configService.templateConf;
  }

  ngOnInit() {
    this.isCustomerAdmin = localStorage.getItem('IsCustomerAdmin') ?  decryptValue(localStorage.getItem('IsCustomerAdmin')) == "Y" ? true : false : false;
    this.isAdmin = JSON.parse(decryptValue(localStorage.getItem('RoleAliasName'))).indexOf('ADMIN') > -1 ? true : false
    const deliveryGuy = JSON.parse(decryptValue(localStorage.getItem('RoleAliasName'))).indexOf('DELIVERY') > -1 ? true : false
    const accesstoAddCylinderInventoryData = localStorage.getItem('boxDataQR') ? decryptValue(localStorage.getItem('boxDataQR')) == 'true' ? true : false : false
    console.log("delivery guy", deliveryGuy)
    if(this.isAdmin || this.isCustomerAdmin){
      HROUTES[0].Role = true
    } else {
      HROUTES[0].Role = false
    }
   this.isCustomer = localStorage.getItem('IsCustomer') ?  decryptValue(localStorage.getItem('IsCustomer')) == "Y" ? true : false : false;
   console.log("isCustomer", this.isCustomer)
 
  //  console.log("this.isCustomer", HROUTES[1].submenu.filter((item) => item.title == 'Upload ASCII')[0].Role)
    if (this.isCustomer) {
      HROUTES[1].submenu.filter((item) => item.title == 'Upload ASCII')[0].Role = false
      HROUTES[1].submenu.filter((item) => item.title == 'ASCII Audits')[0].Role = false
      HROUTES[1].submenu.filter((item) => item.title == 'Archived Samples')[0].Role = false
      HROUTES[1].submenu.filter((item) => item.title == 'Dashboard')[0].Role = false
      HROUTES[1].submenu.filter((item) => item.title == 'Cylinder Box Inventory Details')[0].Role = false
    } else {
      HROUTES[1].submenu.filter((item) => item.title == 'Upload ASCII')[0].Role = true
      HROUTES[1].submenu.filter((item) => item.title == 'ASCII Audits')[0].Role = true
      HROUTES[1].submenu.filter((item) => item.title == 'Archived Samples')[0].Role = true
      HROUTES[1].submenu.filter((item) => item.title == 'Dashboard')[0].Role = true
      HROUTES[1].submenu.filter((item) => item.title == 'Cylinder Box Inventory Details')[0].Role = true
    }

    if(deliveryGuy && accesstoAddCylinderInventoryData) {
      HROUTES[1].submenu.filter((item) => item.title == 'Add Box Data')[0].Role = true
    } else{
      HROUTES[1].submenu.filter((item) => item.title == 'Add Box Data')[0].Role = false
    }
    console.log("HROUTES", HROUTES)
    this.menuItems = HROUTES;
  }

  ngAfterViewInit() {

    this.layoutSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    })
  }

  loadLayout() {

    if (this.config.layout.menuPosition && this.config.layout.menuPosition.toString().trim() != "") {
      this.menuPosition = this.config.layout.menuPosition;
    }


    if (this.config.layout.variant === "Transparent") {
      this.transparentBGClass = this.config.layout.sidebar.backgroundColor;
    }
    else {
      this.transparentBGClass = "";
    }

  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }

}
